import httpHelper from '../utils/httpHelper';
import urlConstants from '../shared/urlConstants';


const updateMyteam = async (rowValue:any,reportId:any) => {
	

	const bodyObj = {
		'organisationId':'techpearl',	
		'comments':rowValue.comment,
		'reportId':reportId,
	};
	
	const params = [
		{ param: '{object}', value: 'dailyreport' },
	];

	return httpHelper.postData(httpHelper.getUri(urlConstants.UPDATE_ITEM, params), JSON.stringify(bodyObj));
};

const sendNotification = async (startDate:any,notifications:any,currentUser:any) => {
	console.log(startDate,'report');
	const bodyObj = {
		'organisationId':'techpearl',	
		'isRead':false,
		'userName':notifications.userName,
		'notificationMessage':`You have received a comment from  ${currentUser} regarding the report submitted on ${startDate}`,
        'notificationTitle':'Comment Added'
	};

	const params = [
		{ param: '{object}', value: 'notification' },
	];

	return httpHelper.postData(httpHelper.getUri(urlConstants.CREATE_ITEM, params), JSON.stringify(bodyObj));

};

export {
	updateMyteam,
	sendNotification
};
